export const iconFontAwesomeTextformattingBorderTopLeft = (
	<i className="fa-solid fa-border-top-left"></i>
);
